function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import './IconChevronUp.css';
import React from 'react';
var IconChevronLeft = function IconChevronLeft(_ref) {
  var _ref$width = _ref.width,
    width = _ref$width === void 0 ? 20 : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? 20 : _ref$height,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    hexColor = _ref.hexColor;
  var hexAtr = hexColor ? {
    fill: hexColor
  } : {};
  return /*#__PURE__*/React.createElement("svg", {
    className: "".concat(className, " ").concat(styles),
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("path", _extends({
    fillRule: "nonzero",
    transform: "rotate(-90 10.41023921966553,10)"
  }, hexAtr, {
    d: "m8.394,5.5l4.606,4.5l-4.606,4.5a1.904,1.904 0 0 1 0,-2.724l1.818,-1.776l-1.818,-1.776a1.904,1.904 0 0 1 0,-2.724z"
  })));
};
var styles = "s3tm56r";
export default IconChevronLeft;